import { graphql, OptionProps } from 'react-apollo';
import { compose } from 'recompose';
import { DemoAthleteQuery } from '../../../clientState/demoAthlete/queries';
import { AthletePayload, AthleteProps } from '../types';
import { withActivityStreamInfo } from '../withAthlete';

const withDemoAthleteCore = graphql<any, AthletePayload, any, AthleteProps>(
    DemoAthleteQuery,
    {
        props: (props: OptionProps<any, any>): AthleteProps => {
            const { data, ownProps } = props;
            if (data) {
                const { demoAthlete, error, loading } = data;

                return {
                    ...ownProps,
                    error,
                    loading,
                    loggedInUser: {
                        user: {
                            athlete: demoAthlete,
                            isAdministrator: false
                        }
                    }
                };
            }
            throw new Error('No athlete provided');
        }
    }
);

export const withDemoAthlete = compose(
    withActivityStreamInfo,
    withDemoAthleteCore
);



// WEBPACK FOOTER //
// ./src/client/components/Strava/Demo/withDemoAthlete.tsx